import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a545f18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "light"
}
const _hoisted_2 = { class: "light-top" }
const _hoisted_3 = { class: "light-desc" }
const _hoisted_4 = { class: "light-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "显示全部", -1))
const _hoisted_6 = { class: "light-right" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "control-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_Switch = _resolveComponent("Switch")!

  return (_ctx.lampList && _ctx.lampList.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.isShowChildLight ? "光照" : _ctx.lampList[0].localName), 1),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.isShowChildLight ? 'light-status' : 'light-status')
            }, _toDisplayString(_ctx.lampSw ? "照明已开启" : "照明已关闭"), 3),
            (_ctx.isShowChildLight)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "show-all",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)), ["stop"]))
                }, [
                  _createVNode(_component_van_icon, {
                    name: _ctx.lightIcon,
                    class: "light-icon"
                  }, null, 8, ["name"]),
                  _hoisted_5
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.lightImg,
              alt: ""
            }, null, 8, _hoisted_7),
            (!_ctx.showFlag)
              ? (_openBlock(), _createBlock(_component_Switch, {
                  key: 0,
                  disabled: !_ctx.userIsControl,
                  modelValue: _ctx.lampSw,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lampSw) = $event)),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.eqChange('allLamp', '', 0))),
                  "inactive-color": "rgba(196, 196, 196, 0.4)",
                  class: "switch-btn"
                }, null, 8, ["disabled", "modelValue"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.showFlag && _ctx.isShowChildLight)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.lampList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "light-control",
                key: item.id
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.localName), 1),
                _createVNode(_component_Switch, {
                  "active-color": "$elActiveColor",
                  disabled: !_ctx.userIsControl,
                  modelValue: item.switch,
                  "onUpdate:modelValue": ($event: any) => ((item.switch) = $event),
                  onClick: ($event: any) => (_ctx.eqChange('main', item, index)),
                  "inactive-color": "rgba(196, 196, 196, 0.2)",
                  class: "switch-btn"
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onClick"])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}